// Function loadGalleryCarousel loads the GalleryCarousel class by dynamically importing the js on demand if needed

export function loadGalleryCarousel($parentEl, isList = false) {

	let $wg = $parentEl.querySelector('[data-wg="GalleryCarousel"]');

	if(!$wg) {
		// console.info('GalleryCarousel: no widget found');
		return Promise.reject('ArticleGallery widget not found in the parent element');
	}

	return import(/* webpackChunkName: "wg-gallery-carousel-chunk" */ '../widgets/galleryCarousel').then(wg => {

		const { GalleryCarousel } = wg;

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="GalleryCarousel"]');
			let instances = [];
			Array.from($wgCol).forEach(($wg, i) => {
				instances.push( new GalleryCarousel($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new GalleryCarousel($wg);
		}


	}).catch(error => error+'An error occurred while loading the GalleryCarousel widget');

}
